import LegalBackgroundStep from './components/Wizard/Steps/LegalBackground';
import UAFFormStep from './components/Wizard/Steps/UAFForm';
import PersonalDocumentsStep from './components/Wizard/Steps/PersonalDocuments';
import BankDataStep from './components/Wizard/Steps/BankData';
import InvestorProfileStep from './components/Wizard/Steps/InvestorProfile';
import ComplementaryInfoStep from './components/Wizard/Steps/ComplementaryInfo';
import ContractStep from './components/Wizard/Steps/Contract';
import FinalStep from './components/Wizard/Steps/Final';

export default [
  {
    title: 'Antecedentes Legales',
    Component: LegalBackgroundStep,
  },
  {
    title: 'Formulario UAF',
    Component: UAFFormStep,
  },
  {
    title: 'Documentos Personales',
    Component: PersonalDocumentsStep,
  },
  {
    title: 'Datos Bancarios y Financieros',
    Component: BankDataStep,
  },
  {
    title: 'Perfil inversionistas',
    Component: InvestorProfileStep,
  },
  {
    title: 'Información Complementaria',
    Component: ComplementaryInfoStep,
  },
  {
    title: 'Contratos',
    Component: ContractStep,
  },
  {
    title: '¡Todo listo!',
    Component: FinalStep,
  },
];
